export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '7fa04799-deb8-4a4a-a65b-7ff67e45b84f'
export const TENANT_ID = process.env.REACT_APP_TENANT_ID || 'a6b367ba-ec52-46fe-86eb-4eb23357a8ab'
export const TOKEN_SCOPE = process.env.REACT_APP_TOKEN_SCOPE || 'api://wtres-apis/.default'
export const PUBLIC_PATH = process.env.REACT_APP_PUBLIC_PATH || 'https://wt-res-dev.wt-dc5-dev.dtek.cloud/'
